var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.job.assignmentGroupNumber)?_c('vs-text',{attrs:{"type":"caption"}},[_vm._v("Assignment Group #"+_vm._s(_vm.job.assignmentGroupNumber)+" > Job #"+_vm._s(_vm.job.number)+" ")]):_c('vs-text',{attrs:{"type":"caption"}},[_vm._v("Job #"+_vm._s(_vm.job.number)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }